<template>
	<div>
		<AppDropdownMenu
			right
			bottom
			absolute
			rounded="lg"
			v-bind="$attrs"
			min-width="230"
			v-on="$listeners"
			:nudge-bottom="10"
			:items="menuItems"
		>
			<template #activator>
				<AnemicButton @click="(e) => e.preventDefault()" width="22" height="22" icon fab x-small class="flex-centerize menu-button">
					<AppIcon name="project-menu-three-dots" class="menu-icon" />
				</AnemicButton>
			</template>
		</AppDropdownMenu>
	</div>
</template>

<script>
import { mapActionsShorthand } from '@/store/utils/mappers';
import { removeWorkflowVersion } from '@/store/modules/workflows/modules/versions/actions.js';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
import { restoreSelectedWorkflowSpecificVersionAsDraft } from '@/store/modules/selectedWorkflow/actions';
import WorkflowVersionService from '@/components/WorkflowVersionHistory/workflow-version-service.js';
export default {
	name: 'WorkflowVersionItemDropdownMenu',
	components: {},
	props: {
		workflowId: { type: Number, required: true },
		allowDelete: { type: Boolean, default: true },
		workflowVersion: { type: Object, required: true },
		isCurrentDraftVersion: { type: Boolean, default: false },
	},
	computed: {
		menuItems() {
			return [
				{ text: 'Restore', onClick: this.restoreVersion },
				{ text: 'Delete', onClick: this.openDeleteVersionDialog, hide: !this.allowDelete },
			].filter((item) => !item.hide);
		},
	},
	methods: {
		...mapActionsShorthand({ removeWorkflowVersion, restoreSelectedWorkflowSpecificVersionAsDraft }),
		restoreVersion() {
			return WorkflowVersionService.restoreVersion({
				router: this.$router,
				workflowId: this.workflowId,
				version: this.workflowVersion.id,
				navigateToVersionAfterCreation: !this.isCurrentDraftVersion,
				restoreSelectedWorkflowSpecificVersionAsDraft: this.restoreSelectedWorkflowSpecificVersionAsDraft,
				hasConfiguration: this.workflowVersion.user_specific_config_options || this.workflowVersion.general_config_options,
			});
		},
		async deleteVersion() {
			try {
				await this.removeWorkflowVersion({ workflowId: this.workflowId, workflowVersionId: this.workflowVersion.id });
				this.$toast.success('Feature version deleted successfully');
			} catch {
				this.$toast.error('Error deleting feature version, please try again later');
			}
		},
		openDeleteVersionDialog() {
			const versionNumber = String(this.workflowVersion.version);
			const dialogProps = {
				noButtonText: 'Cancel',
				yesButtonText: 'Delete',
				onYes: this.deleteVersion,
				confirmationText: versionNumber,
				dangerText: 'This is irreversible.',
				title: 'Are you sure you want to delete this version?',
				verificationDescription: `Please type the version number - "${versionNumber}" to confirm.`,
				areYouSureText: `Are you sure you want to delete feature version number ${versionNumber}?`,
			};
			AppDialogManagerService.openDangerConfirmationDialog(dialogProps);
		},
	},
};
</script>

<style scoped lang="scss">
.menu-button {
	background: transparent !important;
	.menu-icon {
		transform: rotate(90deg);
	}
	&:hover {
		border: 1px solid var(--forth-border-color);
	}
}
</style>
